import { Component, computed, inject } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { TranslocoPipe } from '@jsverse/transloco';

export interface ToastData {
  closable?: boolean;
  message?: string;
  translationMessageKey?: string;
  translationMessageParams?: Record<string, unknown>;
  type: 'info' | 'error' | 'success' | 'warning';
}

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  imports: [MatIconButton, MatIcon, TranslocoPipe]
})
export class ToastComponent {
  public readonly data = inject<ToastData>(MAT_SNACK_BAR_DATA);
  private readonly snackBarRef = inject(MatSnackBarRef<ToastComponent>);

  public readonly isClosable = computed(() => this.data.closable ?? true);

  public close(): void {
    this.snackBarRef.dismiss();
  }
}
